import { render, staticRenderFns } from "./AltUniswapView.vue?vue&type=template&id=765eaff0&scoped=true&"
import script from "./AltUniswapView.vue?vue&type=script&lang=js&"
export * from "./AltUniswapView.vue?vue&type=script&lang=js&"
import style0 from "./AltUniswapView.vue?vue&type=style&index=0&id=765eaff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765eaff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VContainer,VIcon,VOverlay,VProgressCircular,VRadio,VRadioGroup,VSimpleTable})
